// Generated from the WKT files in /routes.
// Geometry is simplified to keep map rendering lightweight.

export const LONGEST_TROLLEYBUS_ROUTE: number[][] = [
  [40.980480, 57.016639],
  [40.980921, 57.016620],
  [40.981185, 57.016867],
  [40.982313, 57.016838],
  [40.983248, 57.016613],
  [40.983783, 57.016221],
  [40.990572, 57.007167],
  [40.990946, 57.006262],
  [40.990976, 57.005253],
  [40.990782, 57.004275],
  [40.990348, 57.003702],
  [40.986728, 57.000693],
  [40.985397, 56.999784],
  [40.982078, 56.997860],
  [40.981115, 56.997241],
  [40.980642, 56.996838],
  [40.980690, 56.996629],
  [40.981228, 56.996305],
  [40.983325, 56.995383],
  [40.984237, 56.995104],
  [40.987231, 56.994535],
  [40.978853, 56.980620],
  [40.978004, 56.979454],
  [40.975074, 56.975792],
  [40.974271, 56.974554],
  [40.973642, 56.971861],
  [40.973644, 56.971515],
  [40.973287, 56.969682],
  [40.973218, 56.969023],
  [40.973280, 56.965070],
  [40.973182, 56.964848],
  [40.972881, 56.964649],
  [40.972861, 56.964511],
  [40.972959, 56.964376],
  [40.973548, 56.964261],
  [40.974336, 56.964484],
  [40.977584, 56.964328],
  [40.995965, 56.963176],
  [40.997185, 56.963177],
  [40.998416, 56.963306],
  [40.999942, 56.963674],
  [41.001105, 56.964127],
  [41.014757, 56.970064],
  [41.025648, 56.962765],
  [41.025528, 56.962503],
  [41.025566, 56.962413],
  [41.025830, 56.962285],
  [41.026499, 56.962243],
  [41.028774, 56.961176],
  [41.035875, 56.964260],
  [41.037460, 56.964864],
  [41.044379, 56.966430],
  [41.046965, 56.966803],
  [41.047727, 56.967043],
  [41.048104, 56.967279],
  [41.052314, 56.970937],
  [41.054298, 56.972670],
  [41.054497, 56.972955],
  [41.054421, 56.973162],
  [41.054124, 56.973339],
  [41.040443, 56.977847],
  [41.040345, 56.978126],
]

export const LONGEST_TRAM_ROUTE: number[][] = [
  [37.604473, 55.643909],
  [37.604495, 55.643479],
  [37.604700, 55.643358],
  [37.605381, 55.643375],
  [37.605638, 55.643647],
  [37.605405, 55.656393],
  [37.605456, 55.656617],
  [37.605661, 55.656905],
  [37.614483, 55.664177],
  [37.618190, 55.663861],
  [37.621352, 55.663446],
  [37.622818, 55.663688],
  [37.623646, 55.664061],
  [37.623876, 55.664293],
  [37.624023, 55.664665],
  [37.623987, 55.667523],
  [37.626134, 55.670195],
  [37.627598, 55.672488],
  [37.627654, 55.673160],
  [37.627554, 55.673849],
  [37.626382, 55.675945],
  [37.624416, 55.681665],
  [37.623819, 55.683844],
  [37.622595, 55.688821],
  [37.620703, 55.698921],
  [37.620733, 55.699329],
  [37.621455, 55.700893],
  [37.622072, 55.702469],
  [37.622012, 55.703075],
  [37.622199, 55.703840],
  [37.622774, 55.704349],
  [37.623984, 55.704994],
  [37.624898, 55.705693],
  [37.624465, 55.708094],
  [37.624787, 55.710132],
  [37.624551, 55.711276],
  [37.624594, 55.711393],
  [37.624831, 55.711477],
  [37.632562, 55.711651],
  [37.632866, 55.711739],
  [37.633040, 55.711897],
  [37.633317, 55.714616],
  [37.633166, 55.715883],
  [37.636387, 55.723249],
  [37.637375, 55.726616],
  [37.637228, 55.728144],
  [37.636881, 55.728816],
  [37.636617, 55.730102],
  [37.635255, 55.731765],
  [37.633954, 55.733945],
  [37.633157, 55.735014],
  [37.631458, 55.736712],
  [37.630194, 55.738883],
  [37.629721, 55.740794],
  [37.629745, 55.742235],
  [37.631459, 55.743092],
  [37.632355, 55.743246],
  [37.633576, 55.743831],
  [37.637459, 55.746222],
  [37.641219, 55.748897],
  [37.641499, 55.749389],
  [37.642241, 55.750276],
  [37.642833, 55.750553],
  [37.643975, 55.750797],
  [37.644608, 55.750774],
  [37.645053, 55.750859],
  [37.645895, 55.751220],
  [37.647492, 55.753032],
  [37.648618, 55.755114],
  [37.648736, 55.755752],
  [37.648700, 55.755948],
  [37.647032, 55.757803],
  [37.646665, 55.758746],
  [37.646281, 55.759332],
  [37.646129, 55.759448],
  [37.645899, 55.760143],
  [37.645908, 55.760621],
  [37.645842, 55.760789],
  [37.644368, 55.762189],
  [37.642307, 55.763371],
  [37.639199, 55.764840],
  [37.638599, 55.765038],
  [37.636944, 55.765788],
  [37.636809, 55.765888],
  [37.636783, 55.766039],
  [37.637067, 55.766280],
  [37.642762, 55.769582],
  [37.647672, 55.773183],
  [37.648504, 55.773658],
  [37.651571, 55.774641],
  [37.652771, 55.774522],
  [37.654279, 55.774989],
  [37.657120, 55.775626],
  [37.658569, 55.776137],
  [37.662684, 55.778020],
  [37.666140, 55.779440],
  [37.667861, 55.778388],
  [37.669171, 55.777459],
  [37.669974, 55.776709],
  [37.670960, 55.776019],
  [37.671383, 55.776142],
  [37.674054, 55.777334],
  [37.677576, 55.775594],
  [37.677797, 55.775397],
  [37.678432, 55.773120],
  [37.679475, 55.768647],
  [37.680287, 55.763969],
  [37.680116, 55.763077],
  [37.684261, 55.762625],
  [37.693790, 55.759138],
  [37.706131, 55.755113],
  [37.711619, 55.753223],
  [37.712173, 55.752945],
  [37.713266, 55.751166],
  [37.713603, 55.751033],
  [37.733900, 55.754950],
  [37.744849, 55.757167],
  [37.745803, 55.757531],
  [37.746833, 55.757770],
  [37.747106, 55.759130],
  [37.747205, 55.759273],
  [37.747499, 55.759406],
  [37.748019, 55.759405],
  [37.748321, 55.759286],
  [37.748430, 55.758537],
  [37.748897, 55.758265],
  [37.751378, 55.758374],
  [37.781584, 55.764304],
  [37.782007, 55.764470],
  [37.782880, 55.765152],
  [37.783340, 55.765158],
  [37.784105, 55.764898],
  [37.787946, 55.758623],
  [37.791594, 55.752325],
  [37.791749, 55.752207],
  [37.792274, 55.752163],
  [37.798335, 55.753354],
  [37.801032, 55.753805],
  [37.819003, 55.751264],
  [37.819150, 55.751135],
  [37.819159, 55.750994],
  [37.816645, 55.745352],
  [37.816079, 55.745129],
]

export const LONGEST_BUS_ROUTE: number[][] = [
  [39.726507, 43.592061],
  [39.726591, 43.592351],
  [39.727291, 43.592087],
  [39.727845, 43.593000],
  [39.730203, 43.595817],
  [39.730575, 43.596541],
  [39.731115, 43.597243],
  [39.731127, 43.597477],
  [39.730182, 43.599824],
  [39.731304, 43.600734],
  [39.732414, 43.601914],
  [39.733401, 43.603458],
  [39.734610, 43.606285],
  [39.735381, 43.606794],
  [39.735836, 43.606710],
  [39.736046, 43.606752],
  [39.736239, 43.606935],
  [39.736229, 43.607072],
  [39.735906, 43.607442],
  [39.735694, 43.607482],
  [39.735339, 43.607407],
  [39.733812, 43.607805],
  [39.731435, 43.608986],
  [39.730977, 43.609315],
  [39.721533, 43.620933],
  [39.721242, 43.621445],
  [39.721252, 43.622636],
  [39.721146, 43.622882],
  [39.717711, 43.626986],
  [39.717364, 43.627506],
  [39.717160, 43.628065],
  [39.716598, 43.628650],
  [39.716023, 43.628953],
  [39.715282, 43.629528],
  [39.714815, 43.630278],
  [39.714720, 43.631043],
  [39.714563, 43.631308],
  [39.714097, 43.631558],
  [39.713518, 43.631666],
  [39.713148, 43.631655],
  [39.712216, 43.631439],
  [39.711381, 43.631549],
  [39.710992, 43.631376],
  [39.710385, 43.630841],
  [39.709923, 43.630592],
  [39.709632, 43.630574],
  [39.709569, 43.630706],
  [39.709700, 43.631445],
  [39.709578, 43.631737],
  [39.708859, 43.632457],
  [39.708117, 43.632984],
  [39.707560, 43.633547],
  [39.705401, 43.634310],
  [39.704448, 43.634958],
  [39.703570, 43.634951],
  [39.702755, 43.635138],
  [39.702489, 43.635282],
  [39.702533, 43.635908],
  [39.702131, 43.636518],
  [39.702120, 43.636692],
  [39.702353, 43.637168],
  [39.702352, 43.637397],
  [39.701744, 43.639917],
  [39.701816, 43.640152],
  [39.701994, 43.640255],
  [39.702426, 43.640277],
  [39.702797, 43.640173],
  [39.702891, 43.639963],
  [39.702837, 43.639823],
  [39.702484, 43.639673],
  [39.700773, 43.639613],
  [39.698792, 43.639386],
  [39.698414, 43.639459],
  [39.698097, 43.639639],
  [39.697943, 43.639921],
  [39.698046, 43.640310],
  [39.699084, 43.641040],
  [39.699650, 43.641970],
  [39.701634, 43.643063],
  [39.701803, 43.643414],
  [39.701636, 43.643734],
  [39.701337, 43.643899],
  [39.700403, 43.644114],
  [39.699210, 43.644109],
  [39.697776, 43.644371],
  [39.696116, 43.644556],
  [39.695954, 43.644695],
  [39.695938, 43.644906],
  [39.696645, 43.645533],
  [39.696605, 43.645681],
  [39.696337, 43.645828],
  [39.695000, 43.645823],
  [39.694056, 43.646041],
  [39.693196, 43.646084],
  [39.690559, 43.646423],
  [39.690316, 43.646542],
  [39.690395, 43.646703],
  [39.691857, 43.647040],
  [39.692187, 43.647237],
  [39.692244, 43.647358],
  [39.692214, 43.647639],
  [39.691173, 43.649118],
  [39.691029, 43.649555],
  [39.691229, 43.650063],
  [39.692792, 43.651902],
  [39.692919, 43.652156],
  [39.692885, 43.652825],
  [39.692635, 43.653438],
  [39.691813, 43.654037],
  [39.691702, 43.654218],
  [39.692029, 43.655327],
  [39.692463, 43.656281],
  [39.692504, 43.656626],
  [39.692113, 43.657814],
  [39.691839, 43.658114],
  [39.691405, 43.658304],
  [39.690466, 43.658471],
  [39.690085, 43.658644],
  [39.689563, 43.659071],
  [39.689102, 43.659762],
  [39.688321, 43.660509],
  [39.687200, 43.661415],
  [39.686921, 43.661505],
  [39.685974, 43.661655],
  [39.683922, 43.661646],
  [39.682045, 43.662245],
  [39.680656, 43.662038],
  [39.678229, 43.662523],
  [39.677758, 43.662419],
  [39.677219, 43.661980],
  [39.676783, 43.661844],
  [39.675158, 43.661872],
  [39.672466, 43.662158],
  [39.670813, 43.662245],
  [39.650455, 43.658908],
  [39.650131, 43.658706],
  [39.648913, 43.657247],
  [39.647260, 43.656804],
  [39.646523, 43.656880],
  [39.645999, 43.656688],
  [39.645872, 43.656535],
  [39.645738, 43.655989],
  [39.645505, 43.655721],
  [39.645409, 43.655332],
  [39.645290, 43.655130],
  [39.645174, 43.655090],
  [39.645120, 43.655170],
  [39.645264, 43.655480],
  [39.645347, 43.656178],
  [39.645215, 43.656451],
  [39.644675, 43.656809],
  [39.644748, 43.657276],
  [39.644961, 43.657558],
  [39.645191, 43.657672],
  [39.645905, 43.657764],
  [39.646496, 43.658096],
  [39.647035, 43.658126],
  [39.647265, 43.658254],
  [39.647327, 43.658469],
  [39.647226, 43.659078],
  [39.646621, 43.659677],
  [39.646317, 43.659727],
  [39.644246, 43.659449],
  [39.643242, 43.659748],
  [39.642496, 43.659850],
  [39.641674, 43.660324],
  [39.641039, 43.660371],
  [39.640238, 43.660216],
  [39.640077, 43.660285],
  [39.639840, 43.660550],
  [39.639603, 43.660646],
  [39.638754, 43.660594],
  [39.638339, 43.660700],
  [39.637325, 43.661451],
  [39.637249, 43.661866],
  [39.637046, 43.662255],
  [39.637033, 43.662437],
  [39.637240, 43.662804],
  [39.637918, 43.663216],
  [39.637987, 43.663405],
  [39.637873, 43.663677],
  [39.637450, 43.664025],
  [39.636786, 43.664375],
  [39.634030, 43.665456],
  [39.633713, 43.665710],
  [39.633377, 43.666345],
  [39.633078, 43.666652],
  [39.632212, 43.666916],
  [39.631526, 43.667317],
  [39.630291, 43.667794],
  [39.629452, 43.668309],
  [39.627051, 43.669083],
  [39.626680, 43.669045],
  [39.626024, 43.668772],
  [39.625693, 43.668720],
  [39.624532, 43.669170],
  [39.624532, 43.669373],
  [39.624689, 43.669479],
  [39.625586, 43.669632],
  [39.625662, 43.669750],
  [39.625528, 43.669833],
  [39.624321, 43.669629],
  [39.623449, 43.669324],
  [39.623236, 43.669073],
  [39.623387, 43.668857],
  [39.624246, 43.668352],
  [39.624575, 43.667988],
  [39.625013, 43.667718],
  [39.625630, 43.667513],
  [39.625652, 43.667430],
  [39.625564, 43.667371],
  [39.624327, 43.667580],
  [39.623305, 43.668114],
  [39.622258, 43.668547],
  [39.621824, 43.668847],
  [39.621612, 43.669595],
  [39.621067, 43.670046],
  [39.621130, 43.670751],
  [39.621558, 43.671410],
  [39.621522, 43.671545],
  [39.621348, 43.671658],
  [39.621090, 43.671689],
  [39.620917, 43.671624],
  [39.620008, 43.670815],
  [39.619635, 43.669856],
  [39.618903, 43.669121],
  [39.618261, 43.668834],
  [39.617633, 43.668373],
  [39.616839, 43.668243],
  [39.616277, 43.668033],
  [39.615594, 43.668024],
  [39.615389, 43.667842],
  [39.615218, 43.667460],
  [39.615002, 43.667461],
  [39.614948, 43.667586],
  [39.615003, 43.667832],
  [39.615444, 43.668705],
  [39.615390, 43.668969],
  [39.615111, 43.669484],
  [39.615156, 43.669787],
  [39.615307, 43.669880],
  [39.615545, 43.669865],
  [39.616727, 43.669508],
  [39.616883, 43.669525],
  [39.617054, 43.669677],
  [39.616975, 43.670690],
  [39.617535, 43.671381],
  [39.617882, 43.672782],
  [39.617731, 43.673386],
  [39.617273, 43.673990],
  [39.615872, 43.674952],
  [39.610736, 43.676678],
  [39.610375, 43.676694],
  [39.609498, 43.676499],
  [39.609011, 43.676087],
  [39.608744, 43.676057],
  [39.608514, 43.676144],
  [39.608034, 43.676638],
  [39.607539, 43.676873],
  [39.607149, 43.676933],
  [39.606447, 43.676831],
  [39.605405, 43.677359],
  [39.604557, 43.677306],
  [39.604188, 43.677522],
  [39.603633, 43.678034],
  [39.602335, 43.678787],
  [39.602069, 43.679695],
  [39.600299, 43.681980],
  [39.598568, 43.684031],
  [39.597906, 43.685188],
  [39.597320, 43.685842],
  [39.596813, 43.686675],
  [39.595660, 43.688000],
  [39.594286, 43.688885],
  [39.593044, 43.690626],
  [39.592641, 43.691654],
  [39.591428, 43.692928],
  [39.591224, 43.693806],
  [39.590036, 43.695271],
  [39.588221, 43.698730],
  [39.585934, 43.702362],
  [39.584241, 43.703578],
  [39.582290, 43.704516],
  [39.582124, 43.704821],
  [39.582192, 43.705486],
  [39.582030, 43.705756],
  [39.580955, 43.706227],
  [39.580065, 43.706159],
  [39.579760, 43.706221],
  [39.578405, 43.707241],
  [39.577060, 43.708837],
  [39.576754, 43.710441],
  [39.576178, 43.711231],
  [39.575861, 43.712340],
  [39.575757, 43.712489],
  [39.575472, 43.712563],
  [39.574121, 43.712343],
  [39.573391, 43.712141],
  [39.573164, 43.712208],
  [39.573128, 43.712313],
  [39.573404, 43.712872],
  [39.573471, 43.713622],
  [39.573342, 43.714380],
  [39.572920, 43.715218],
  [39.572841, 43.715544],
  [39.573025, 43.716673],
  [39.573366, 43.717175],
  [39.573698, 43.717432],
  [39.575539, 43.718449],
  [39.575964, 43.719256],
  [39.575968, 43.719739],
  [39.575595, 43.720773],
  [39.573975, 43.724831],
  [39.573723, 43.725133],
  [39.571878, 43.725941],
  [39.564813, 43.728754],
  [39.564266, 43.728768],
  [39.561754, 43.728513],
  [39.559367, 43.728939],
  [39.552370, 43.729255],
  [39.551864, 43.729390],
  [39.549962, 43.730337],
  [39.549558, 43.730726],
  [39.549385, 43.731011],
  [39.548623, 43.733124],
  [39.548591, 43.733436],
  [39.548761, 43.733906],
  [39.550279, 43.736577],
  [39.550323, 43.736755],
  [39.550260, 43.736915],
  [39.550012, 43.737104],
  [39.548653, 43.737602],
  [39.541378, 43.739429],
  [39.539504, 43.739737],
  [39.539047, 43.739976],
  [39.538701, 43.740476],
  [39.538727, 43.741437],
  [39.538450, 43.743060],
  [39.538407, 43.744742],
  [39.537412, 43.746867],
  [39.537131, 43.747108],
  [39.535511, 43.747806],
  [39.533647, 43.748264],
  [39.531254, 43.749090],
  [39.530947, 43.749532],
  [39.530872, 43.749780],
  [39.531076, 43.751357],
  [39.530936, 43.752234],
  [39.530842, 43.752438],
  [39.530637, 43.752609],
  [39.530124, 43.752815],
  [39.529586, 43.752827],
  [39.528343, 43.752385],
  [39.527862, 43.752358],
  [39.527466, 43.752592],
  [39.526635, 43.753412],
  [39.526068, 43.753574],
  [39.525532, 43.753539],
  [39.524331, 43.753109],
  [39.523988, 43.753113],
  [39.523792, 43.753264],
  [39.523447, 43.753768],
  [39.523086, 43.754813],
  [39.522860, 43.755111],
  [39.520765, 43.756306],
  [39.520648, 43.756636],
  [39.520729, 43.757659],
  [39.520589, 43.757954],
  [39.517685, 43.760145],
  [39.517152, 43.760288],
  [39.516046, 43.760232],
  [39.512991, 43.759187],
  [39.512042, 43.758761],
  [39.511733, 43.758714],
  [39.511419, 43.758775],
  [39.509938, 43.759455],
  [39.509786, 43.759643],
  [39.509536, 43.760313],
  [39.509305, 43.760491],
  [39.508296, 43.760718],
  [39.507645, 43.760953],
  [39.507000, 43.761319],
  [39.505886, 43.762146],
  [39.504016, 43.762897],
  [39.502707, 43.764081],
  [39.500130, 43.765878],
  [39.499784, 43.766358],
  [39.499285, 43.767725],
  [39.498893, 43.768030],
  [39.502672, 43.772926],
  [39.503764, 43.773299],
  [39.504266, 43.773661],
  [39.503739, 43.773329],
  [39.502631, 43.772946],
  [39.499579, 43.769075],
  [39.498850, 43.768048],
  [39.497435, 43.768497],
  [39.497039, 43.768516],
  [39.495700, 43.768350],
  [39.494789, 43.768467],
  [39.494324, 43.768658],
  [39.492527, 43.770097],
  [39.489600, 43.771699],
  [39.489187, 43.772071],
  [39.488725, 43.772748],
  [39.487953, 43.773630],
  [39.486130, 43.775160],
  [39.485686, 43.775314],
  [39.483551, 43.775619],
  [39.482777, 43.775951],
  [39.482584, 43.776170],
  [39.482554, 43.776416],
  [39.482634, 43.776638],
  [39.483097, 43.777231],
  [39.483175, 43.778616],
  [39.482943, 43.778904],
  [39.482268, 43.779282],
  [39.481952, 43.779586],
  [39.481312, 43.781725],
  [39.481413, 43.783021],
  [39.481931, 43.784843],
  [39.481958, 43.785348],
  [39.481830, 43.785928],
  [39.481988, 43.787048],
  [39.482303, 43.788426],
  [39.482125, 43.788636],
  [39.481571, 43.788955],
  [39.480282, 43.789261],
  [39.480113, 43.789536],
  [39.480252, 43.789756],
  [39.481012, 43.790193],
  [39.481290, 43.790864],
  [39.482228, 43.791355],
  [39.482371, 43.791585],
  [39.482362, 43.791964],
  [39.481967, 43.792183],
  [39.481501, 43.792173],
  [39.481014, 43.792043],
  [39.480228, 43.791530],
  [39.479701, 43.791457],
  [39.479360, 43.791518],
  [39.478953, 43.791880],
  [39.479146, 43.792655],
  [39.479160, 43.793034],
  [39.478851, 43.793426],
  [39.478376, 43.793644],
  [39.477355, 43.793935],
  [39.476678, 43.794289],
  [39.473749, 43.796403],
  [39.471811, 43.798430],
  [39.470906, 43.798968],
  [39.469226, 43.799668],
  [39.470877, 43.798939],
  [39.471772, 43.798407],
  [39.473714, 43.796377],
  [39.476644, 43.794263],
  [39.477335, 43.793902],
  [39.478357, 43.793611],
  [39.478813, 43.793402],
  [39.479111, 43.793027],
  [39.479097, 43.792661],
  [39.478905, 43.791872],
  [39.479080, 43.791647],
  [39.479335, 43.791486],
  [39.479706, 43.791421],
  [39.480249, 43.791497],
  [39.481038, 43.792012],
  [39.481506, 43.792137],
  [39.481953, 43.792148],
  [39.482317, 43.791948],
  [39.482323, 43.791594],
  [39.482186, 43.791375],
  [39.481255, 43.790890],
  [39.481134, 43.790734],
  [39.480969, 43.790211],
  [39.480217, 43.789782],
  [39.480063, 43.789535],
  [39.480252, 43.789232],
  [39.481542, 43.788925],
  [39.482091, 43.788610],
  [39.482254, 43.788419],
  [39.481939, 43.787054],
  [39.481780, 43.785927],
  [39.481909, 43.785345],
  [39.481881, 43.784847],
  [39.481363, 43.783024],
  [39.481262, 43.781724],
  [39.481905, 43.779575],
  [39.482239, 43.779253],
  [39.482904, 43.778882],
  [39.483126, 43.778609],
  [39.483048, 43.777239],
  [39.482591, 43.776655],
  [39.482504, 43.776419],
  [39.482537, 43.776157],
  [39.482742, 43.775925],
  [39.483536, 43.775585],
  [39.485674, 43.775279],
  [39.486098, 43.775132],
  [39.487913, 43.773609],
  [39.489416, 43.771785],
  [39.492495, 43.770070],
  [39.493916, 43.768883],
  [39.494437, 43.768556],
  [39.494941, 43.768399],
  [39.495695, 43.768314],
  [39.497044, 43.768481],
  [39.497424, 43.768462],
  [39.498893, 43.768030],
  [39.497435, 43.768497],
  [39.497039, 43.768516],
  [39.495700, 43.768350],
  [39.494949, 43.768434],
  [39.494465, 43.768586],
  [39.493950, 43.768909],
  [39.492527, 43.770097],
  [39.489452, 43.771810],
  [39.487953, 43.773630],
  [39.486130, 43.775160],
  [39.485686, 43.775314],
  [39.483278, 43.775689],
  [39.482777, 43.775951],
  [39.482584, 43.776170],
  [39.482577, 43.776527],
  [39.483097, 43.777231],
  [39.483175, 43.778616],
  [39.482943, 43.778904],
  [39.482268, 43.779282],
  [39.481952, 43.779586],
  [39.481312, 43.781725],
  [39.481413, 43.783021],
  [39.481931, 43.784843],
  [39.481958, 43.785348],
  [39.481830, 43.785928],
  [39.481988, 43.787048],
  [39.482303, 43.788426],
  [39.482125, 43.788636],
  [39.481571, 43.788955],
  [39.480282, 43.789261],
  [39.480113, 43.789536],
  [39.480252, 43.789756],
  [39.481012, 43.790193],
  [39.481229, 43.790811],
  [39.482311, 43.791449],
  [39.482413, 43.791840],
  [39.482281, 43.792058],
  [39.481967, 43.792183],
  [39.481501, 43.792173],
  [39.481014, 43.792043],
  [39.480228, 43.791530],
  [39.479701, 43.791457],
  [39.479360, 43.791518],
  [39.478953, 43.791880],
  [39.479146, 43.792655],
  [39.479160, 43.793034],
  [39.478851, 43.793426],
  [39.478376, 43.793644],
  [39.477355, 43.793935],
  [39.476678, 43.794289],
  [39.473749, 43.796403],
  [39.471811, 43.798430],
  [39.470906, 43.798968],
  [39.469140, 43.799710],
  [39.468584, 43.799714],
  [39.467010, 43.798731],
  [39.465476, 43.798792],
  [39.464453, 43.798685],
  [39.461273, 43.799034],
  [39.460662, 43.798884],
  [39.459826, 43.798886],
  [39.459628, 43.798836],
  [39.459102, 43.798475],
  [39.458403, 43.798311],
  [39.457761, 43.798327],
  [39.457388, 43.798429],
  [39.457279, 43.798668],
  [39.457527, 43.799095],
  [39.457516, 43.799293],
  [39.456763, 43.800143],
  [39.455878, 43.801320],
  [39.455352, 43.803620],
  [39.455126, 43.803669],
  [39.455002, 43.803566],
  [39.455279, 43.802030],
  [39.455171, 43.801414],
  [39.454877, 43.801312],
  [39.453989, 43.801318],
  [39.453582, 43.801410],
  [39.453179, 43.801615],
  [39.452561, 43.802285],
  [39.451287, 43.804528],
  [39.450024, 43.805577],
  [39.449935, 43.805894],
  [39.450018, 43.806504],
  [39.449933, 43.806674],
  [39.449051, 43.806962],
  [39.448464, 43.807580],
  [39.448391, 43.808197],
  [39.448294, 43.808365],
  [39.446600, 43.809380],
  [39.445897, 43.810379],
  [39.445824, 43.810608],
  [39.445836, 43.811418],
  [39.445621, 43.811805],
  [39.444966, 43.812384],
  [39.444866, 43.812768],
  [39.444951, 43.813168],
  [39.445053, 43.813396],
  [39.445343, 43.813686],
  [39.445615, 43.813815],
  [39.445971, 43.813788],
  [39.446707, 43.813433],
  [39.446954, 43.813476],
  [39.447086, 43.814526],
  [39.447047, 43.815047],
  [39.447296, 43.815671],
  [39.447410, 43.816461],
  [39.447964, 43.817100],
  [39.447965, 43.817241],
  [39.447819, 43.817466],
  [39.447141, 43.817745],
  [39.446772, 43.817716],
  [39.446649, 43.817597],
  [39.446289, 43.816703],
  [39.445788, 43.816379],
  [39.445301, 43.815922],
  [39.444529, 43.815714],
  [39.442726, 43.814773],
  [39.442447, 43.814762],
  [39.442147, 43.814885],
  [39.441858, 43.815231],
  [39.441816, 43.815746],
  [39.441706, 43.815960],
  [39.441262, 43.816375],
  [39.440509, 43.817414],
  [39.437800, 43.820397],
  [39.437881, 43.820727],
  [39.439431, 43.821709],
  [39.439427, 43.821961],
  [39.439198, 43.822066],
  [39.438631, 43.822058],
  [39.436718, 43.821578],
  [39.436444, 43.821649],
  [39.436088, 43.822035],
  [39.436088, 43.822616],
  [39.436295, 43.822865],
  [39.437171, 43.823541],
  [39.437455, 43.824472],
  [39.437630, 43.824789],
  [39.438688, 43.825579],
  [39.438705, 43.825726],
  [39.438388, 43.826275],
  [39.438174, 43.826361],
  [39.437973, 43.826297],
  [39.437343, 43.825862],
  [39.436447, 43.825488],
  [39.435147, 43.824654],
  [39.434938, 43.824681],
  [39.434830, 43.824809],
  [39.434934, 43.826200],
  [39.434847, 43.826378],
  [39.434679, 43.826484],
  [39.434437, 43.826451],
  [39.434146, 43.825982],
  [39.433347, 43.825418],
  [39.433119, 43.825312],
  [39.432890, 43.825324],
  [39.431809, 43.826015],
  [39.431298, 43.826533],
  [39.430051, 43.827225],
  [39.428998, 43.828112],
  [39.421101, 43.832696],
  [39.420459, 43.833243],
  [39.420124, 43.833637],
  [39.419658, 43.834524],
  [39.419337, 43.836317],
  [39.419736, 43.836781],
  [39.420031, 43.837272],
  [39.420669, 43.837727],
  [39.420966, 43.837793],
  [39.421490, 43.837693],
  [39.421787, 43.837806],
  [39.421810, 43.838616],
  [39.421708, 43.838855],
  [39.421486, 43.839046],
  [39.420943, 43.839106],
  [39.419964, 43.838856],
  [39.418865, 43.838271],
  [39.417936, 43.838173],
  [39.417584, 43.838263],
  [39.417013, 43.839401],
  [39.416391, 43.839953],
  [39.416148, 43.840385],
  [39.416539, 43.841193],
  [39.417420, 43.841655],
  [39.417383, 43.841814],
  [39.416925, 43.842123],
  [39.416883, 43.842266],
  [39.417292, 43.842999],
  [39.417372, 43.843373],
  [39.417331, 43.843667],
  [39.417027, 43.843876],
  [39.416648, 43.843859],
  [39.415144, 43.842328],
  [39.414878, 43.842207],
  [39.414539, 43.842291],
  [39.414175, 43.842582],
  [39.413250, 43.844034],
  [39.412603, 43.844481],
  [39.412486, 43.844679],
  [39.412345, 43.845311],
  [39.412376, 43.845973],
  [39.412288, 43.846155],
  [39.411896, 43.846450],
  [39.410660, 43.846889],
  [39.409571, 43.848187],
  [39.409411, 43.848848],
  [39.409433, 43.849205],
  [39.410038, 43.850499],
  [39.410469, 43.850945],
  [39.410673, 43.851368],
  [39.411075, 43.852818],
  [39.411342, 43.853417],
  [39.411290, 43.853654],
  [39.409656, 43.854406],
  [39.409172, 43.854395],
  [39.408913, 43.854065],
  [39.408848, 43.853302],
  [39.408754, 43.853088],
  [39.407669, 43.852528],
  [39.407368, 43.851966],
  [39.407206, 43.851816],
  [39.406740, 43.851699],
  [39.406371, 43.851748],
  [39.406233, 43.851870],
  [39.406070, 43.852342],
  [39.406084, 43.852628],
  [39.406463, 43.853200],
  [39.407105, 43.854455],
  [39.407233, 43.854727],
  [39.407229, 43.854918],
  [39.407001, 43.855043],
  [39.406706, 43.855026],
  [39.405597, 43.854404],
  [39.405261, 43.854429],
  [39.404360, 43.855588],
  [39.402241, 43.858048],
  [39.402259, 43.858202],
  [39.402441, 43.858390],
  [39.403275, 43.858719],
  [39.404449, 43.858926],
  [39.404704, 43.859119],
  [39.404730, 43.859333],
  [39.404541, 43.859573],
  [39.403843, 43.859869],
  [39.403204, 43.859958],
  [39.403062, 43.860045],
  [39.403013, 43.860210],
  [39.403236, 43.860733],
  [39.404352, 43.861528],
  [39.404571, 43.862100],
  [39.405286, 43.863190],
  [39.405256, 43.864861],
  [39.405088, 43.865095],
  [39.404251, 43.865719],
  [39.404047, 43.866427],
  [39.402423, 43.867738],
  [39.401825, 43.867995],
  [39.401106, 43.868168],
  [39.400290, 43.867997],
  [39.399959, 43.868003],
  [39.399248, 43.868407],
  [39.399019, 43.868692],
  [39.398845, 43.869347],
  [39.398876, 43.870105],
  [39.398746, 43.870168],
  [39.397882, 43.870188],
  [39.397327, 43.870584],
  [39.397083, 43.870954],
  [39.396970, 43.871320],
  [39.397015, 43.872040],
  [39.397218, 43.872644],
  [39.397445, 43.872982],
  [39.398081, 43.873477],
  [39.398453, 43.873593],
  [39.399282, 43.873605],
  [39.400409, 43.874191],
  [39.400458, 43.874374],
  [39.400162, 43.874838],
  [39.400263, 43.875221],
  [39.400693, 43.876134],
  [39.400890, 43.876356],
  [39.401303, 43.876617],
  [39.401478, 43.876936],
  [39.401398, 43.877281],
  [39.400927, 43.877998],
  [39.399416, 43.879678],
  [39.398600, 43.881041],
  [39.398559, 43.881389],
  [39.398818, 43.882143],
  [39.398754, 43.882345],
  [39.398489, 43.882467],
  [39.397092, 43.882736],
  [39.396238, 43.883173],
  [39.396112, 43.883357],
  [39.396071, 43.883728],
  [39.396219, 43.884392],
  [39.396130, 43.884640],
  [39.395737, 43.884881],
  [39.395423, 43.884916],
  [39.394372, 43.884556],
  [39.392986, 43.884446],
  [39.391369, 43.884027],
  [39.388739, 43.884563],
  [39.386836, 43.883901],
  [39.385570, 43.883676],
  [39.385150, 43.883785],
  [39.383924, 43.884317],
  [39.381944, 43.884096],
  [39.379771, 43.884626],
  [39.376982, 43.884751],
  [39.375821, 43.885055],
  [39.371714, 43.885390],
  [39.371328, 43.885307],
  [39.368212, 43.883963],
  [39.366531, 43.883693],
  [39.366040, 43.883755],
  [39.365832, 43.883873],
  [39.365471, 43.884404],
  [39.365429, 43.884820],
  [39.365326, 43.885001],
  [39.364662, 43.885353],
  [39.364503, 43.885511],
  [39.364434, 43.885686],
  [39.364464, 43.886197],
  [39.364312, 43.886460],
  [39.363289, 43.887065],
  [39.362026, 43.887184],
  [39.361553, 43.887354],
  [39.360917, 43.888024],
  [39.359782, 43.888769],
  [39.358700, 43.889650],
  [39.355768, 43.891322],
  [39.352614, 43.894074],
  [39.352173, 43.894380],
  [39.351452, 43.894800],
  [39.350502, 43.895160],
  [39.349210, 43.896246],
  [39.347073, 43.896848],
  [39.344463, 43.898944],
  [39.341177, 43.901207],
  [39.339796, 43.902303],
  [39.339419, 43.902686],
  [39.337884, 43.904757],
  [39.337088, 43.905463],
  [39.336539, 43.905822],
  [39.335854, 43.905650],
  [39.335035, 43.905885],
  [39.325581, 43.912140],
  [39.324501, 43.913277],
  [39.319963, 43.916147],
]
